import { POST } from '@/api'
import { parse } from 'date-fns'
import { isEqual } from 'lodash'

const INITIAL_SETTINGS = {
  dinnerId: null,
  lunchId: null,
  customStart: '',
  customEnd: '',
  customDinnerId: null,
  customLunchId: null,
  isUse: false,
  isMain: false,
  isSetPeriod: false,
}

export default {
  namespaced: true,
  state: {
    origin: {},
    settings: INITIAL_SETTINGS,
    busy: false,
  },
  mutations: {
    set(state, obj) {
      state.settings = { ...INITIAL_SETTINGS, ...obj }
      state.origin = { ...INITIAL_SETTINGS, ...obj }
    },
    update(state, value) {
      if (value.isSetPeriod) {
        if (!state.settings.customLunchId) state.settings.customLunchId = state.settings.lunchId
        if (!state.settings.customDinnerId) state.settings.customDinnerId = state.settings.dinnerId
      }
      state.settings = { ...state.settings, ...value }
    },
    reset(state) {
      state.settings = { ...state.origin }
    },
    busy(state, value) {
      state.busy = value
    },
  },
  getters: {
    layoutIdByDateByZone({ settings }) {
      const customStart = parse(settings.customStart)
      const customEnd = parse(settings.customEnd)
      return date => {
        date = parse(date)
        const isCustom = settings.isSetPeriod && customStart <= date && date <= customEnd
        return {
          dinner: isCustom ? settings.customDinnerId : settings.dinnerId,
          lunch: isCustom ? settings.customLunchId : settings.lunchId,
        }
      }
    },
    changed(state) {
      return !isEqual(state.origin, state.settings)
    },
  },
  actions: {
    async get(store) {
      const { commit, rootState } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/layouts/options/detail', {
        storeId: rootState.stores.current.store.id,
      })
      if (status === 200) {
        commit('set', data.options)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async save({ state, commit }) {
      if (state.busy) return
      commit('busy', true)

      const { isUse, isMain } = state.settings
      state.settings.isMain = isUse ? isMain : false

      const { status, message } = await POST('/api/web/layouts/options/regist', {
        ...state.settings,
      })
      if (status === 200) {
        commit('set', state.settings)
      } else {
        commit('app/error', { status, message }, { root: true })
      }
      commit('busy', false)
    },
  },
}
